"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var AppSpinner_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/app-spinner/AppSpinner"));
var ScreenCard_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/card/ScreenCard"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../../redux/reducers/authentication/actions");
var framework_1 = require("../../../widgets/framework");
var ResendActivationDialog_1 = __importDefault(require("../../LoginWidget/components/resend-activation/ResendActivationDialog"));
var ResendActivationEmailSentDialog_1 = __importDefault(require("../../LoginWidget/components/resend-activation/ResendActivationEmailSentDialog"));
var styles_1 = __importDefault(require("../styles"));
var ACTIVATION_TYPES = {
    success: {
        message: 'activation.success.message',
        title: 'activation.success.title'
    },
    active: {
        message: 'activation.active.message',
        title: 'activation.active.title'
    },
    expired: {
        message: 'activation.expired.message',
        title: 'activation.expired.title'
    },
    notFound: {
        message: 'activation.notFound.message',
        title: 'activation.notFound.title'
    },
    error: {
        message: 'activation.error.message',
        title: 'activation.error.title'
    }
};
var ActivationContent = function (_a) {
    var _b;
    var type = _a.type, loading = _a.loading;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var title;
    var gotoArea;
    var displayBox;
    var button;
    var _c = react_1.default.useState(false), showResendDialog = _c[0], setShowResendDialog = _c[1];
    var _d = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), resendMailSent = _d.resendMailSent, emailAddress = _d.emailAddress;
    var onNavigateToResendActivation = function () {
        setShowResendDialog(true);
    };
    var redirectToLogin = function () {
        var appNavigate = {
            action: 'LOGIN'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var closeResendActivationDialog = function () {
        setShowResendDialog(false);
    };
    var closeEmailSentDialog = function () {
        dispatch((0, actions_1.resetResendMail)());
        redirectToLogin();
    };
    if (!loading) {
        var pass = type === 'active' || type === 'success';
        var icon = pass ? 'done' : 'error_outline';
        var content = ACTIVATION_TYPES[type];
        if (!content) {
            content = { title: 'activation.error.title', message: type };
        }
        title = t(content.title);
        displayBox = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Icon, { className: (0, classnames_1.default)((_b = {},
                    _b[classes.icon] = true,
                    _b[classes.iconSuccess] = pass,
                    _b[classes.iconError] = !pass,
                    _b)) }, icon),
            react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.gotoText }, t(content.message))));
        gotoArea = (react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.gotoText }, "Go to"));
        button = pass ? (react_1.default.createElement(core_1.Button, { size: "large", variant: "outlined", color: "primary", "aria-label": "Sign In", onClick: redirectToLogin }, "Sign In")) : (react_1.default.createElement(core_1.Button, { size: "large", variant: "outlined", color: "primary", "aria-label": "Resend Activation", onClick: onNavigateToResendActivation }, "Resend Activation"));
    }
    else {
        title = 'Account Activating';
        displayBox = (react_1.default.createElement("div", { className: classes.loadingBox },
            react_1.default.createElement(AppSpinner_1.default, { customStyles: {
                    backgroundColor: 'transparent'
                } })));
    }
    return (react_1.default.createElement(ScreenCard_1.default, { title: title },
        react_1.default.createElement(core_1.Grid, { container: true, justify: "center", alignItems: "center" },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 11, sm: 9, lg: 8 },
                react_1.default.createElement("div", { className: classes.box }, displayBox))),
        gotoArea,
        button,
        react_1.default.createElement(ResendActivationDialog_1.default, { show: showResendDialog, onSuccessCallback: closeResendActivationDialog, closeReactivationDialog: closeResendActivationDialog }),
        react_1.default.createElement(ResendActivationEmailSentDialog_1.default, { show: resendMailSent, email: emailAddress, okayCallback: closeEmailSentDialog })));
};
exports.default = ActivationContent;
//# sourceMappingURL=ActivationContent.js.map